const LinearProgress = () => {
  return (
    <div className={'relative w-full h-1 bg-gray-200 overflow-hidden'}>
      <div className="absolute w-1/5 top-0 left-0 h-full bg-blue-2 animate-linear-progress"></div>
    </div>
  );
};

export default LinearProgress;
